// Styled component import
import styled from "styled-components";

// Types
type WrapperType = {
  height: number;
  open: boolean;
};

export const Wrapper = styled.div<WrapperType>`
  .banner {
    width: 100vw;
    height: 180px;
    position: relative;
    margin: -40px 0vw 0;
    :after {
      content: "";
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 60%,
        rgba(0, 0, 0, 0.8) 100%
      );
    }
    transition: all 0.8s cubic-bezier(0.39, 0.07, 0.23, 1);
  }
  img.banner_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  img.store_logo {
    width: 60px;
    height: 60px;
    position: absolute;
    right: 25px;
    bottom: -30px;
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid rgb(255 255 255);
  }
  .info {
    position: relative;
    margin: 30px 5vw 0;
  }
  h3 {
    font-weight: 600;
  }
  h4 {
    font-weight: normal;
    color: ${(props) => props.theme.palette.textSecondary};
  }
  .check {
    display: none;
    position: absolute;
    left: 20px;
  }
  .selected {
    display: block;
  }
  .delivery-settings {
    width: 120px;
    height: 30px;
    background-color: ${(props) => props.theme.backgroundAccent}cf;
    backdrop-filter: blur(15px);
    border-radius: 20px;
    position: absolute;
    left: 0px;
    top: -50px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5px;
    padding: 5px;
    button {
      display: flex;
      color: ${(props) => props.theme.palette.textPrimary};
      justify-content: center;
      align-items: center;
      font-size: 14px;
      background-color: transparent;
      padding-bottom: 5px;
      position: relative;
      z-index: 9;
      border-radius: 15px;
      transition: all 0.5s cubic-bezier(0.45, -0.32, 0.13, 1.32);
    }
    :after {
      content: "";
      position: absolute;
      top: 5px;
      width: calc(50% - 10px);
      height: 30px;
      background-color: ${(props) => props.theme.palette.primary};
      border-radius: 15px;
      box-shadow: 0px 5px 10px 0px rgba(255, 95, 80, 0.25);
      transition: all 0.5s cubic-bezier(0.45, -0.32, 0.13, 1.32);
    }
  }
  .products-list-container {
    display: grid;
    grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
    grid-gap: 15px;
    padding: 20px 15px;
    height: ${(props) => (props.open === true ? props.height + "px" : "0px")};
    overflow: hidden;
    white-space: nowrap;
    transition: all 0.3s cubic-bezier(0.46, 0.13, 0.35, 1);
  }
  .pickup {
    button.pickup-btn {
      color: white;
    }
    :after {
      left: 5px;
    }
  }
  .delivery {
    button.delivery-btn {
      color: white;
    }
    :after {
      left: calc(50% + 5px);
    }
  }
  hr.separator {
    width: 90vw;
    height: 1px;
    border-bottom: 1px solid #f8f8f8;
    margin: 5vw;
  }
  .search {
    margin: 5vw;
    display: flex;
  }
  .address-row svg {
    margin-bottom: -3px;
  }
  .address-list div:last-child hr {
    border-bottom: 0;
  }
  span.address {
    margin: 0 5vw;
    width: 80%;
    display: inline-block;
  }
  .status {
    position: absolute;
    left: 0;
    top: 10px;
    z-index: 9999;
    margin: 0 auto;
    display: block;
    text-align: center;
    width: fit-content;
    padding: 5px 15px 10px 15px;
    color: white;
    border-radius: 20px;
    font-size: 12px;
    box-shadow: 0px 10px 10px 4px rgba(190, 191, 197, 0.2);
    transition: all 0.8s cubic-bezier(0.42, 0.13, 0.12, 1) 0.4s;
  }
  .status__open {
    background-color: ${(props) => props.theme.success};
  }
  .status__closed {
    background-color: ${(props) => props.theme.palette.textAccent};
  }
  .status__busy {
    background-color: ${(props) => props.theme.error};
  }
  .pickup-address {
    margin: 5vw;
    background-color: ${(props) => props.theme.backgroundAccent};
    padding: 15px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    span {
      margin-top: -3px;
      font-size: 12px;
      color: ${(props) => props.theme.palette.textSecondary};
    }
    label {
      font-size: 14px;
    }
  }
  .work-time {
    width: 60%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .work-hours {
    margin: 5vw;
    display: flex;
    flex-direction: column;
    span {
      margin-top: -3px;
      font-size: 12px;
      color: ${(props) => props.theme.palette.textSecondary};
    }
    label {
      font-size: 14px;
    }
  }
  .branch {
    background-color: ${(props) => props.theme.backgroundAccent};
    width: 160px;
    height: 45px;
    margin-top: 15px;
    border-radius: 30px;
    .input-container {
      height: 40px;
      padding-right: 15px;
    }
    .adorment.adorment__right {
      height: 30px;
    }
    ul {
      left: unset;
      right: 0;
    }
  }
  .list-container {
    display: flex;
    align-items: center;
  }
  .tags {
    display: flex;
    align-items: center;
    margin-right: 15px;
  }
`;

type ModalProps = {
  open: boolean;
};

export const Modal = styled.div<ModalProps>`
  width: 100%;
  height: 95vh;
  background: white;
  position: fixed;
  bottom: ${(props) => (props.open ? "0" : "-100vh")};
  z-index: 999999;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  overflow: scroll;
  transition: all 0.3s cubic-bezier(0.39, 0.07, 0.23, 1);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  svg {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 24px;
    height: 24px;
    opacity: 0.4;
  }
`;

type TagProps = {
  selected: boolean;
};

export const Tag = styled.div<TagProps>`
  height: 35px;
  padding: 0px 15px 5px 15px;
  background-color: ${(props) =>
    props.selected
      ? props.theme.palette.primary
      : props.theme.backgroundAccent};
  color: ${(props) => (props.selected ? "white" : "inherit")};

  display: inline-block;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  box-shadow: ${(props) =>
    props.selected ? "0px 4px 10px 0px rgba(255, 95, 80, 0.25)" : "none"};
  transition: all 0.2s cubic-bezier(0.39, 0.07, 0.23, 1);
`;

export const Counter = styled.div`
  height: 51px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 30px;
  margin: 0 10px 0 -20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 5px;
  div {
    background-color: #ffffff;
    height: 39px;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    span {
      font-size: 16px;
      font-weight: bold;
      color: ${(props) => props.theme.palette.primary};
      padding-bottom: 5px;
      letter-spacing: 0px;
    }
  }
`;
